/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Expected_CommissionInputs */

const cs_deals_expected_commission = /** @type {(inputs: Deals_Expected_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávaná provize`)
};

const en_deals_expected_commission = /** @type {(inputs: Deals_Expected_CommissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected commission`)
};

/**
* | output |
* | --- |
* | "Expected commission" |
*
* @param {Deals_Expected_CommissionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_expected_commission = /** @type {((inputs?: Deals_Expected_CommissionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Expected_CommissionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_expected_commission(inputs)
	return cs_deals_expected_commission(inputs)
});